import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import 'core-js/modules/es6.number.constructor.js';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import _extends from '@babel/runtime/helpers/esm/extends';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _styled from '@emotion/styled-base';
import 'core-js/modules/es6.object.to-string.js';
import 'core-js/modules/es6.array.iterator.js';
import 'core-js/modules/web.dom.iterable.js';
import 'core-js/modules/es6.array.find.js';
import 'core-js/modules/es6.regexp.split.js';
import 'core-js/modules/es6.function.name.js';
import 'core-js/modules/es6.string.includes.js';
import 'core-js/modules/es7.array.includes.js';
import 'core-js/modules/es6.array.map.js';
import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.array.filter.js';
import React__default, { createContext, forwardRef, useReducer, useEffect, useContext, useState, useRef } from 'react';
import { backgroundMidtone, borderRadiusLarge, background, intentPrimary, borderRadiusFull, intentPrimaryTranslucentHover, borderRadiusSmall, border, intentDanger, borderInput, breakpointMaxSmall } from '../theme/theme.js';
import { AddAlt32, ChevronDown32, SubtractAlt32 } from '@carbon/icons-react';
import { Button } from '../button/button.js';
import { IconOnlyButton } from '../icon-only-button/icon-only-button.js';
import { Tag } from '@blueprintjs/core';
import { FormGroup } from '../form-group/form-group.js';
import cx from 'classnames';
import { Icon } from '../icon/icon.js';
import { v4 } from 'uuid';
import * as R from 'ramda';
import { useMedia } from 'react-use';
import { ConditionBuilderCombinator } from './condition-builder-combinator.js';
import { ConditionBuilderHeader } from './condition-builder-header.js';
import { ConditionBuilderFooter, ConditionBuilderFooterPlaceholder } from './condition-builder-footer.js';
import { ConditionalBuilderPopoverMenu } from './condition-builder-popover-menu.js';
import { ConditionalBuilderInputValue, ConditionalBuilderNumericValue, ConditionalBuilderDateValue } from './conditional-builder-value-fields.js';
import { Text } from '../text/text.js';

var _excluded = ["dispatch", "readOnly", "vertical"],
    _excluded2 = ["dispatch"],
    _excluded3 = ["dispatch", "conditionsData", "readOnly", "vertical"],
    _excluded4 = ["andCombinatorTagText", "addConditionText", "addSubConditionText", "className", "clearPredeterminedValueButtonTooltipText", "combinatorsEditable", "conditionsData", "dateValuePlaceholderText", "defaultConditionsData", "ifAllCombinatorSelectionText", "ifAnyCombinatorSelectionText", "ifAllCombinatorDescriptionText", "ifAnyCombinatorDescriptionText", "initialCombinatorValue", "maxDepth", "noResultsText", "onConditionsChange", "operatorLabelText", "operators", "operatorsEditable", "orCombinatorTagText", "readOnly", "searchInputClearSearchButtonTooltipText", "searchInputLabelAndPlaceholderText", "selectValuePlaceholderText", "sourceColumns", "sourceLabelText", "sourcePlaceholderText", "stringValuePlaceholderText", "subConditionMaxLimitText", "t", "usePredeterminedValueButtonTooltipText", "usingPredeterminedValueIconTooltipText", "valueLabelText", "vertical"];

var _defaultTranslation;

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TranslationKeys;

(function (TranslationKeys) {
  TranslationKeys["conditionBuilderAndCombinatorTagText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-and-combinator-tag-text";
  TranslationKeys["conditionBuilderOrCombinatorTagText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-or-combinator-tag-text";
  TranslationKeys["conditionBuilderIfAllCombinatorSelectionText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-if-all-combinator-selection-text";
  TranslationKeys["conditionBuilderIfAnyCombinatorSelectionText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-if-any-combinator-selection-text";
  TranslationKeys["conditionBuilderIfAllCombinatorDescriptionText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-if-all-combinator-description-text";
  TranslationKeys["conditionBuilderIfAnyCombinatorDescriptionText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-if-any-combinator-description-text";
  TranslationKeys["conditionBuilderAddConditionText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-add-condition-text";
  TranslationKeys["conditionBuilderAddSubConditionText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-add-sub-condition-text";
  TranslationKeys["conditionBuilderSubConditionMaxLimitText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-sub-condition-max-limit-text";
  TranslationKeys["conditionBuilderSourceLabelText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-source-label-text";
  TranslationKeys["conditionBuilderSourcePlaceholderText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-source-placeholder-text";
  TranslationKeys["conditionBuilderOperatorLabelText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-operator-label-text";
  TranslationKeys["conditionBuilderValueLabelText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-value-label-text";
  TranslationKeys["conditionBuilderStringValuePlaceholderText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-string-value-placeholder-text";
  TranslationKeys["conditionBuilderDateValuePlaceholderText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-date-value-placeholder-text";
  TranslationKeys["conditionBuilderSelectValuePlaceholderText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-select-value-placeholder-text";
  TranslationKeys["conditionBuilderUsingPredeterminedValueIconTooltipText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-using-predetermined-value-icon-tooltip-text";
  TranslationKeys["conditionBuilderUsePredeterminedValueButtonTooltipText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-use-predetermined-value-button-tooltip-text";
  TranslationKeys["conditionBuilderClearPredeterminedValueButtonTooltipText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-clear-predetermined-value-button-tooltip-text";
  TranslationKeys["conditionBuilderSearchInputLabelAndPlaceholderText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-search-input-label-and-placeholder-text";
  TranslationKeys["conditionBuilderSearchInputClearSearchButtonTooltipText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-search-input-clear-search-text";
  TranslationKeys["conditionBuilderNoResultsText"] = "varicent-design-system.vds-condition-builder.vds-condition-builder-no-results-text";
})(TranslationKeys || (TranslationKeys = {}));

var defaultTranslation = (_defaultTranslation = {}, _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderAndCombinatorTagText, function () {
  return "AND";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderOrCombinatorTagText, function () {
  return "OR";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderIfAllCombinatorSelectionText, function () {
  return "If all";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderIfAnyCombinatorSelectionText, function () {
  return "If any";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderIfAllCombinatorDescriptionText, function () {
  return "If all of the following are true";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderIfAnyCombinatorDescriptionText, function () {
  return "If any of the following are true";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderAddConditionText, function () {
  return "Add condition";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderAddSubConditionText, function () {
  return "Add sub-condition";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderSubConditionMaxLimitText, function () {
  return "You’ve reached the maximum number of sub-conditions for this condition";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderSourceLabelText, function () {
  return "Source";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderSourcePlaceholderText, function () {
  return "Select a source";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderOperatorLabelText, function () {
  return "Operator";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderValueLabelText, function () {
  return "Value";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderStringValuePlaceholderText, function () {
  return "Value";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderDateValuePlaceholderText, function () {
  return "M/D/YYYY";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderSelectValuePlaceholderText, function () {
  return "Select a value";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderUsingPredeterminedValueIconTooltipText, function () {
  return "Using predetermined value";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderUsePredeterminedValueButtonTooltipText, function () {
  return "Use predetermined value";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderClearPredeterminedValueButtonTooltipText, function () {
  return "Clear predetermined value";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderSearchInputLabelAndPlaceholderText, function () {
  return "Search";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderSearchInputClearSearchButtonTooltipText, function () {
  return "Clear search";
}), _defineProperty(_defaultTranslation, TranslationKeys.conditionBuilderNoResultsText, function () {
  return "No results";
}), _defaultTranslation);

var defaultTranslate = function defaultTranslate(arg) {
  return defaultTranslation[arg.id](arg.values);
};

var ConditionBuilderWrapper = /*#__PURE__*/_styled("div", {
  target: "exy9x1f0"
})("padding:", function (_ref) {
  var vertical = _ref.vertical;
  return vertical ? "0.5rem" : "1rem";
}, ";background-color:", backgroundMidtone, ";border-radius:", borderRadiusLarge, ";");

var ConditionBuilderGroupWrapper = /*#__PURE__*/_styled("div", {
  target: "exy9x1f1"
})("position:relative;display:flex;flex-direction:column;gap:0.5rem;&.vds-condition-builder-group-depth-odd{background-color:", backgroundMidtone, ";}&.vds-condition-builder-group-depth-even{background-color:", background, ";}> .vds-condition-builder-group{padding:", function (_ref2) {
  var readOnly = _ref2.readOnly,
      vertical = _ref2.vertical;
  return readOnly && vertical ? "0.5rem 0.5rem 0.5rem 3.625rem" : "0.75rem 0.5rem 0.5rem 3.625rem";
}, ";border-radius:", borderRadiusLarge, ";> .vds-condition-builder-header{margin-left:-2.875rem;}&::before,&::after{content:\"\";position:absolute;top:-0.5rem;bottom:0;left:1.84375rem;width:1px;background-repeat:repeat;background-image:linear-gradient( 0,transparent 75%,", intentPrimary, " 75% );background-size:1px 0.25rem;background-position:0 1px;}&:before{top:", function (_ref3) {
  var vertical = _ref3.vertical;
  return vertical && "-1rem";
}, ";bottom:auto;height:", function (_ref4) {
  var combinatorEditable = _ref4.combinatorEditable,
      readOnly = _ref4.readOnly,
      vertical = _ref4.vertical;
  return readOnly && vertical ? "1.5rem" : !combinatorEditable && !vertical || readOnly ? "1.25rem" : !combinatorEditable && vertical ? "1.75rem" : vertical ? "2rem" : "1.5rem";
}, ";}&:nth-child(2):nth-last-child(2)::before{top:", function (_ref5) {
  var vertical = _ref5.vertical;
  return vertical && "-0.5rem";
}, ";height:2.25rem;}&:nth-child(2):not(:nth-last-child(2))::before{top:", function (_ref6) {
  var vertical = _ref6.vertical;
  return vertical && "-0.5rem";
}, ";bottom:", function (_ref7) {
  var vertical = _ref7.vertical;
  return vertical ? "0.5rem" : "0";
}, ";height:auto;}&:after{top:", function (_ref8) {
  var readOnly = _ref8.readOnly,
      vertical = _ref8.vertical;
  return readOnly && vertical ? "2rem" : readOnly ? "2.25rem" : "2.5rem";
}, ";bottom:", function (_ref9) {
  var vertical = _ref9.vertical;
  return vertical && "0.5rem";
}, ";}&:nth-child(2)::after,&:nth-last-child(2)::after{display:none;}&:nth-child(2):nth-last-child(2)::after{top:1.5rem;left:1.625rem;display:block;width:0.5rem;height:0.5rem;background-color:", intentPrimary, ";background-image:none;border-radius:", borderRadiusFull, ";}}");

var ConditionBuilderRuleWrapper = /*#__PURE__*/_styled("div", {
  target: "exy9x1f2"
})("position:relative;display:flex;flex-wrap:", function (_ref10) {
  var readOnly = _ref10.readOnly,
      vertical = _ref10.vertical;
  return !readOnly && vertical && "wrap";
}, ";flex-direction:row;align-self:", function (_ref11) {
  var readOnly = _ref11.readOnly;
  return readOnly && "flex-start";
}, ";align-items:flex-start;gap:0.25rem;width:", function (_ref12) {
  var readOnly = _ref12.readOnly,
      vertical = _ref12.vertical;
  return readOnly && vertical && "100%";
}, ";padding:", function (_ref13) {
  var readOnly = _ref13.readOnly,
      vertical = _ref13.vertical;
  return readOnly && vertical ? "0.5rem 1rem 0.5rem 0.5rem" : readOnly ? "0.25rem 1rem 0.25rem 0.5rem" : vertical ? "0.5rem" : "0.25rem 0.5rem";
}, ";background-color:", intentPrimaryTranslucentHover, ";border-radius:", borderRadiusSmall, ";&::before,&::after{content:\"\";position:absolute;top:-0.5rem;bottom:0;left:1.84375rem;width:1px;background-repeat:repeat;background-image:linear-gradient(0,transparent 75%,", intentPrimary, " 75%);background-size:1px 0.25rem;background-position:0 1px;}&::before{top:", function (_ref14) {
  var vertical = _ref14.vertical;
  return vertical && "-1rem";
}, ";bottom:auto;height:", function (_ref15) {
  var readOnly = _ref15.readOnly,
      vertical = _ref15.vertical;
  return readOnly && vertical ? "1.5rem" : vertical ? "1.75rem" : "1rem";
}, ";}&:nth-child(2)::before{top:-0.5rem;bottom:", function (_ref16) {
  var readOnly = _ref16.readOnly,
      vertical = _ref16.vertical;
  return readOnly && vertical ? "0.5rem" : vertical ? "auto" : "0";
}, ";height:", function (_ref17) {
  var readOnly = _ref17.readOnly,
      vertical = _ref17.vertical;
  return readOnly && vertical ? "auto" : vertical ? "3.25rem" : "auto";
}, ";}&:nth-last-child(2)::before{bottom:auto;height:", function (_ref18) {
  var readOnly = _ref18.readOnly,
      vertical = _ref18.vertical;
  return vertical && readOnly ? "1.5rem" : vertical ? "1.75rem" : "1rem";
}, ";}&:nth-child(2):nth-last-child(2)::before{height:", function (_ref19) {
  var readOnly = _ref19.readOnly,
      vertical = _ref19.vertical;
  return !readOnly && vertical ? "2rem" : "1.75rem";
}, ";}&::after{top:", function (_ref20) {
  var readOnly = _ref20.readOnly,
      vertical = _ref20.vertical;
  return !readOnly && vertical ? "2.25rem" : "2rem";
}, ";bottom:", function (_ref21) {
  var readOnly = _ref21.readOnly,
      vertical = _ref21.vertical;
  return !readOnly && vertical && "auto";
}, ";height:", function (_ref22) {
  var readOnly = _ref22.readOnly,
      vertical = _ref22.vertical;
  return !readOnly && vertical && "0.5rem";
}, ";}&:nth-child(2)::after,&:nth-last-child(2)::after{display:none;}&:nth-child(2):nth-last-child(2)::after{top:", function (_ref23) {
  var readOnly = _ref23.readOnly,
      vertical = _ref23.vertical;
  return !readOnly && vertical ? "1.25rem" : "1rem";
}, ";left:1.625rem;display:block;width:0.5rem;height:0.5rem;background-color:", intentPrimary, ";background-image:none;border-radius:", borderRadiusFull, ";}");

var ConditionBuilderReadOnlyWrapper = /*#__PURE__*/_styled("div", {
  target: "exy9x1f3"
})("display:flex;flex-direction:", function (_ref24) {
  var vertical = _ref24.vertical;
  return vertical ? "column" : "row";
}, ";gap:0.25rem;align-items:", function (_ref25) {
  var vertical = _ref25.vertical;
  return vertical && "flex-start";
}, ";");

var ConditionBuilderSourceColumnElement = /*#__PURE__*/_styled("div", {
  target: "exy9x1f4"
})("display:flex;flex-direction:row;gap:0.25rem;align-items:center;min-height:1.5rem;padding:0 0.5rem 0 0.25rem;margin:", function (_ref26) {
  var vertical = _ref26.vertical;
  return !vertical && "0.25rem 0";
}, ";font-weight:600;background-color:", background, ";border:1px solid ", border, ";border-radius:", borderRadiusSmall, ";");

var ConditionBuilderOperatorTagWrapper = /*#__PURE__*/_styled("div", {
  target: "exy9x1f5"
})("flex:0 0 auto !important;padding:", function (_ref27) {
  var readOnly = _ref27.readOnly,
      vertical = _ref27.vertical;
  return readOnly && vertical ? "0" : readOnly ? "0.25rem 0" : "0.25rem 1rem";
}, ";margin:", function (_ref28) {
  var readOnly = _ref28.readOnly,
      vertical = _ref28.vertical;
  return !readOnly && !vertical && "0 auto";
}, ";&:not(:first-child):not(:last-child) .bp3-tag{border-radius:", borderRadiusFull, " !important;}");

var ConditionBuilderStaticValue = /*#__PURE__*/_styled("div", {
  target: "exy9x1f6"
})("margin:", function (_ref29) {
  var vertical = _ref29.vertical;
  return !vertical && "0.375rem 0";
}, ";font-weight:600;");

var ConditionBuilderFormGroupWrapper = /*#__PURE__*/_styled("div", {
  target: "exy9x1f7"
})("display:flex;flex-direction:column;order:", function (_ref30) {
  var vertical = _ref30.vertical;
  return vertical && "2";
}, ";width:100%;.vds-condition-builder-form-group{margin-bottom:0;}");

var ConditionBuilderFormElements = /*#__PURE__*/_styled("div", {
  target: "exy9x1f8"
})("display:flex;flex-direction:", function (_ref31) {
  var vertical = _ref31.vertical;
  return vertical ? "column" : "row";
}, ";> *{flex:1 1 33.333%;&:focus,& button.vds-select:focus{position:relative;z-index:1;}}button,input{border-radius:", function (_ref32) {
  var operatorsEditable = _ref32.operatorsEditable;
  return operatorsEditable && "0 !important";
}, ";}>:not(:first-child):not(:last-child):not( .vds-condition-builder-operator-wrapper ) button.vds-select{background-color:", background, " !important;box-shadow:", function (_ref33) {
  var hasError = _ref33.hasError;
  return hasError ? "inset 0 1px ".concat(intentDanger, ", inset 0 -1px ").concat(intentDanger, " !important") : "inset 0 1px ".concat(borderInput, ", inset 0 -1px ").concat(borderInput, " !important");
}, ";}>:nth-child(2):last-child:not(.vds-condition-builder-operator-wrapper) button.vds-select{background-color:", background, " !important;box-shadow:", function (_ref34) {
  var hasError = _ref34.hasError;
  return hasError ? "inset 0 1px 0 ".concat(intentDanger, ", inset -1px 0 ").concat(intentDanger, ",\n      inset 0 -1px ").concat(intentDanger, " !important") : "inset 0 1px 0 ".concat(borderInput, ", inset -1px 0 ").concat(borderInput, ",\n      inset 0 -1px ").concat(borderInput, " !important");
}, ";}", function (_ref35) {
  var hasError = _ref35.hasError,
      operatorsEditable = _ref35.operatorsEditable,
      vertical = _ref35.vertical;
  return operatorsEditable && vertical && "\n    > :not(:first-child):not(:last-child):not(.vds-condition-builder-operator-wrapper)\n      button.vds-select {\n      box-shadow:\n        inset 1px 0 ".concat(hasError ? intentDanger : borderInput, ",\n        inset -1px 0 ").concat(hasError ? intentDanger : borderInput, " !important;\n    }\n\n    > :nth-child(2):last-child:not(.vds-condition-builder-operator-wrapper)\n      button.vds-select {\n      box-shadow:\n        inset 1px 0 ").concat(hasError ? intentDanger : borderInput, ",\n        inset -1px 0 ").concat(hasError ? intentDanger : borderInput, ",\n        inset 0 -1px ").concat(hasError ? intentDanger : borderInput, " !important;\n    }\n  ");
}, " >:first-child,>:first-child button.vds-select{border-top-left-radius:", borderRadiusSmall, " !important;border-top-right-radius:", function (_ref36) {
  var vertical = _ref36.vertical,
      operatorsEditable = _ref36.operatorsEditable;
  return operatorsEditable && vertical && "".concat(borderRadiusSmall, " !important");
}, ";border-bottom-left-radius:", function (_ref37) {
  var vertical = _ref37.vertical,
      operatorsEditable = _ref37.operatorsEditable;
  return operatorsEditable && !vertical && "".concat(borderRadiusSmall, " !important");
}, ";}>:last-child,>:last-child input,>:last-child button.vds-select{border-top-right-radius:", function (_ref38) {
  var vertical = _ref38.vertical,
      operatorsEditable = _ref38.operatorsEditable;
  return operatorsEditable && !vertical && "".concat(borderRadiusSmall, " !important");
}, ";border-bottom-right-radius:", borderRadiusSmall, " !important;border-bottom-left-radius:", function (_ref39) {
  var vertical = _ref39.vertical,
      operatorsEditable = _ref39.operatorsEditable;
  return operatorsEditable && vertical && "".concat(borderRadiusSmall, " !important");
}, ";}[class*=\"text-overflow-ellipsis\"]{max-width:140px;}");

var ConditionBuilderFormGroupError = /*#__PURE__*/_styled("div", {
  target: "exy9x1f9"
})("margin-top:0.25rem;color:", intentDanger, ";");

var ConditionBuilderRuleActions = /*#__PURE__*/_styled("div", {
  target: "exy9x1f10"
})("display:flex;flex-direction:row;gap:0.25rem;margin-left:", function (_ref40) {
  var vertical = _ref40.vertical;
  return vertical && "auto";
}, ";");

var ConditionBuilderContext = /*#__PURE__*/createContext({
  andCombinatorTagText: "",
  addConditionText: "",
  addSubConditionText: "",
  clearPredeterminedValueButtonTooltipText: "",
  combinatorsEditable: true,
  conditionsData: {
    rootId: null,
    conditions: {}
  },
  dateValuePlaceholderText: "",
  dispatch: function dispatch() {},
  ifAllCombinatorSelectionText: "",
  ifAnyCombinatorSelectionText: "",
  ifAllCombinatorDescriptionText: "",
  ifAnyCombinatorDescriptionText: "",
  maxDepth: 3,
  noResultsText: "",
  operatorLabelText: "",
  operators: {
    string: [],
    number: [],
    date: []
  },
  operatorsEditable: true,
  orCombinatorTagText: "",
  readOnly: false,
  searchInputClearSearchButtonTooltipText: "",
  searchInputLabelAndPlaceholderText: "",
  selectValuePlaceholderText: "",
  sourceColumns: [],
  sourceLabelText: "",
  sourcePlaceholderText: "",
  stringValuePlaceholderText: "",
  subConditionMaxLimitText: "",
  t: defaultTranslate,
  usePredeterminedValueButtonTooltipText: "",
  usingPredeterminedValueIconTooltipText: "",
  valueLabelText: "",
  vertical: false
});

var ConditionBuilderGroup = function ConditionBuilderGroup(_ref41) {
  var _context$andCombinato, _context$ifAllCombina, _context$ifAllCombina2, _context$ifAnyCombina, _context$ifAnyCombina2, _context$orCombinator, _context$addCondition, _context$addSubCondit, _context$subCondition;

  var children = _ref41.children,
      combinator = _ref41.combinator,
      depth = _ref41.depth,
      groupId = _ref41.groupId,
      groupCombinator = _ref41.groupCombinator;

  var _useContext = useContext(ConditionBuilderContext),
      dispatch = _useContext.dispatch,
      readOnly = _useContext.readOnly,
      vertical = _useContext.vertical,
      context = _objectWithoutProperties(_useContext, _excluded);

  return /*#__PURE__*/React__default.createElement(ConditionBuilderGroupWrapper, {
    className: "vds-condition-builder-group vds-condition-builder-group-depth-".concat(depth % 2 ? "even" : "odd"),
    combinatorEditable: context.combinatorsEditable,
    readOnly: readOnly,
    vertical: vertical
  }, /*#__PURE__*/React__default.createElement(ConditionBuilderHeader, {
    andCombinatorTagText: (_context$andCombinato = context.andCombinatorTagText) !== null && _context$andCombinato !== void 0 ? _context$andCombinato : context.t({
      id: TranslationKeys.conditionBuilderAndCombinatorTagText
    }),
    combinator: combinator,
    combinatorEditable: context.combinatorsEditable,
    dispatch: dispatch,
    groupId: groupId,
    ifAllCombinatorDescriptionText: (_context$ifAllCombina = context.ifAllCombinatorDescriptionText) !== null && _context$ifAllCombina !== void 0 ? _context$ifAllCombina : context.t({
      id: TranslationKeys.conditionBuilderIfAllCombinatorDescriptionText
    }),
    ifAllCombinatorSelectionText: (_context$ifAllCombina2 = context.ifAllCombinatorSelectionText) !== null && _context$ifAllCombina2 !== void 0 ? _context$ifAllCombina2 : context.t({
      id: TranslationKeys.conditionBuilderIfAllCombinatorSelectionText
    }),
    ifAnyCombinatorDescriptionText: (_context$ifAnyCombina = context.ifAnyCombinatorDescriptionText) !== null && _context$ifAnyCombina !== void 0 ? _context$ifAnyCombina : context.t({
      id: TranslationKeys.conditionBuilderIfAnyCombinatorDescriptionText
    }),
    ifAnyCombinatorSelectionText: (_context$ifAnyCombina2 = context.ifAnyCombinatorSelectionText) !== null && _context$ifAnyCombina2 !== void 0 ? _context$ifAnyCombina2 : context.t({
      id: TranslationKeys.conditionBuilderIfAnyCombinatorSelectionText
    }),
    orCombinatorTagText: (_context$orCombinator = context.orCombinatorTagText) !== null && _context$orCombinator !== void 0 ? _context$orCombinator : context.t({
      id: TranslationKeys.conditionBuilderOrCombinatorTagText
    }),
    readOnly: readOnly,
    selectedCombinator: groupCombinator,
    vertical: vertical
  }), children, !readOnly ? /*#__PURE__*/React__default.createElement(ConditionBuilderFooter, {
    addConditionText: (_context$addCondition = context.addConditionText) !== null && _context$addCondition !== void 0 ? _context$addCondition : context.t({
      id: TranslationKeys.conditionBuilderAddConditionText
    }),
    addSubConditionText: (_context$addSubCondit = context.addSubConditionText) !== null && _context$addSubCondit !== void 0 ? _context$addSubCondit : context.t({
      id: TranslationKeys.conditionBuilderAddSubConditionText
    }),
    depth: depth,
    dispatch: dispatch,
    groupId: groupId,
    maxDepth: context.maxDepth,
    subConditionMaxLimitText: (_context$subCondition = context.subConditionMaxLimitText) !== null && _context$subCondition !== void 0 ? _context$subCondition : context.t({
      id: TranslationKeys.conditionBuilderSubConditionMaxLimitText
    })
  }) :
  /*#__PURE__*/
  // Used to help preserve CSS for dotted connector lines.
  React__default.createElement(ConditionBuilderFooterPlaceholder, null));
};

var ConditionBuilderRule = function ConditionBuilderRule(_ref42) {
  var _context$andCombinato2, _context$orCombinator2, _getSelectedOperatorO, _context$sourceLabelT, _context$noResultsTex, _sourceInputRef$curre2, _context$searchInputC, _context$searchInputL, _context$sourcePlaceh, _context$operatorLabe, _selectedSourceColumn, _operatorInputRef$cur2, _getSelectedOperatorO2, _getSelectedOperatorO3, _context$valueLabelTe, _selectedSourceColumn2, _context$noResultsTex2, _valueInputRef$curren5, _context$searchInputC2, _context$searchInputL2, _context$clearPredete, _context$stringValueP, _context$usingPredete, _context$clearPredete2, _context$usingPredete2, _context$clearPredete3, _context$dateValuePla, _context$usePredeterm, _context$usingPredete3;

  var combinator = _ref42.combinator,
      ruleId = _ref42.ruleId;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      sourcePopoverOpen = _useState2[0],
      setSourcePopoverOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      operatorPopoverOpen = _useState4[0],
      setOperatorPopoverOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      valuePopoverOpen = _useState6[0],
      setValuePopoverOpen = _useState6[1];

  var sourceInputRef = useRef(null);
  var operatorInputRef = useRef(null);
  var valueInputRef = useRef(null);

  var _useContext2 = useContext(ConditionBuilderContext),
      dispatch = _useContext2.dispatch,
      context = _objectWithoutProperties(_useContext2, _excluded2);

  var currentCondition = context.conditionsData.conditions[ruleId];
  var selectedSourceColumnObj = context.sourceColumns.find(function (column) {
    return column.id === currentCondition["selectedSourceColumnId"];
  });

  var getSelectedOperatorObj = function getSelectedOperatorObj() {
    var _context$sourceColumn;

    var sourceColumnsDataType = (_context$sourceColumn = context.sourceColumns.find(function (column) {
      return column.id === currentCondition["selectedSourceColumnId"];
    })) === null || _context$sourceColumn === void 0 ? void 0 : _context$sourceColumn.dataType;

    if (!sourceColumnsDataType) {
      throw new Error("Current operator type does not exist");
    }

    return context.operators[sourceColumnsDataType].find(function (operator) {
      return operator.id === currentCondition["selectedOperator"];
    });
  };

  var getDateString = function getDateString(date) {
    var dateArray = typeof date === "string" ? new Date(date).toISOString().split("T")[0].split("-") : date.toISOString().split("T")[0].split("-");
    var year = dateArray[0];
    var month = dateArray[1];
    var day = dateArray[2];
    return month + "/" + day + "/" + year;
  };

  var handelValueInputClick = function handelValueInputClick(valueInputRef) {
    var _valueInputRef$curren;

    (selectedSourceColumnObj === null || selectedSourceColumnObj === void 0 ? void 0 : selectedSourceColumnObj.selectItems) && setValuePopoverOpen(true); // Required to prevent focus from entering popover before intended.

    if ( // Related to hack to fix issue with NumericInput component's ref prop.
    (_valueInputRef$curren = valueInputRef.current) !== null && _valueInputRef$curren !== void 0 && _valueInputRef$curren.classList.contains("vds-condition-builder-numeric-input-wrapper-ref")) {
      valueInputRef.current.querySelector("input").focus();
    } else {
      valueInputRef.current.focus();
    }
  };

  var handelKeyDown = function handelKeyDown(e, type) {
    if (e.key === "Escape") {
      type === "source" && setSourcePopoverOpen(false);
      type === "operator" && setOperatorPopoverOpen(false);
      type === "value" && setValuePopoverOpen(false);
    }

    if (e.key !== "Tab" && e.key !== "CapsLock" && e.key !== "Shift" && e.key !== "Control" && e.key !== "Alt" && e.key !== "Meta" && e.key !== "Escape") {
      type === "source" && setSourcePopoverOpen(true);
      type === "operator" && setOperatorPopoverOpen(true);
      type === "value" && setValuePopoverOpen(true);
    }

    if (e.key === "Tab" || e.key === "ArrowDown") {
      if (sourcePopoverOpen || operatorPopoverOpen || valuePopoverOpen) {
        e.preventDefault();
        var searchInput = document.querySelector(".vds-condition-builder-popover-menu-search-input input");

        if (searchInput) {
          searchInput.focus();
        } else {
          var _document$querySelect;

          (_document$querySelect = document.querySelector(".vds-condition-builder-popover-menu-item")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.focus();
        }
      }
    }
  };

  var SourceColumnIconIncoming = selectedSourceColumnObj === null || selectedSourceColumnObj === void 0 ? void 0 : selectedSourceColumnObj.icon;
  return /*#__PURE__*/React__default.createElement(ConditionBuilderRuleWrapper, {
    className: "vds-condition-builder-rule",
    operatorsEditable: context.operatorsEditable,
    readOnly: context.readOnly,
    vertical: context.vertical
  }, /*#__PURE__*/React__default.createElement(ConditionBuilderCombinator, {
    andCombinatorTagText: (_context$andCombinato2 = context.andCombinatorTagText) !== null && _context$andCombinato2 !== void 0 ? _context$andCombinato2 : context.t({
      id: TranslationKeys.conditionBuilderAndCombinatorTagText
    }),
    combinator: combinator,
    orCombinatorTagText: (_context$orCombinator2 = context.orCombinatorTagText) !== null && _context$orCombinator2 !== void 0 ? _context$orCombinator2 : context.t({
      id: TranslationKeys.conditionBuilderOrCombinatorTagText
    }),
    readOnly: context.readOnly,
    vertical: context.vertical
  }), context.readOnly ? selectedSourceColumnObj && /*#__PURE__*/React__default.createElement(ConditionBuilderReadOnlyWrapper, {
    vertical: context.vertical
  }, /*#__PURE__*/React__default.createElement(ConditionBuilderSourceColumnElement, {
    vertical: context.vertical
  }, SourceColumnIconIncoming && /*#__PURE__*/React__default.createElement(Icon, null, /*#__PURE__*/React__default.createElement(SourceColumnIconIncoming, null)), selectedSourceColumnObj.name), /*#__PURE__*/React__default.createElement(ConditionBuilderOperatorTagWrapper, {
    className: "vds-condition-builder-operator-wrapper",
    readOnly: true,
    vertical: context.vertical
  }, /*#__PURE__*/React__default.createElement(Tag, {
    intent: "primary"
  }, (_getSelectedOperatorO = getSelectedOperatorObj()) === null || _getSelectedOperatorO === void 0 ? void 0 : _getSelectedOperatorO.name)), currentCondition["value"] && /*#__PURE__*/React__default.createElement(ConditionBuilderStaticValue, {
    vertical: context.vertical
  }, currentCondition["type"] === "date" ? getDateString(currentCondition["value"]) : currentCondition["type"] !== "string" && currentCondition["type"] !== "number" && currentCondition["type"] !== "date" ? "[".concat(currentCondition["value"], "]") : currentCondition["value"])) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ConditionBuilderFormGroupWrapper, {
    vertical: context.vertical
  }, /*#__PURE__*/React__default.createElement(ConditionBuilderFormElements, {
    className: "vds-condition-builder-form-elements",
    hasError: !!currentCondition["error"],
    operatorsEditable: context.operatorsEditable,
    vertical: context.vertical
  }, /*#__PURE__*/React__default.createElement(FormGroup, {
    className: "vds-condition-builder-form-group",
    label: (_context$sourceLabelT = context.sourceLabelText) !== null && _context$sourceLabelT !== void 0 ? _context$sourceLabelT : context.t({
      id: TranslationKeys.conditionBuilderSourceLabelText
    }),
    hideLabel: true,
    intent: !!currentCondition["error"] ? "danger" : undefined
  }, /*#__PURE__*/React__default.createElement(ConditionalBuilderPopoverMenu, {
    activeItem: selectedSourceColumnObj === null || selectedSourceColumnObj === void 0 ? void 0 : selectedSourceColumnObj.name,
    isOpen: sourcePopoverOpen,
    menuItems: context.sourceColumns,
    noResultsText: (_context$noResultsTex = context.noResultsText) !== null && _context$noResultsTex !== void 0 ? _context$noResultsTex : context.t({
      id: TranslationKeys.conditionBuilderNoResultsText
    }),
    onOpenChange: function onOpenChange(updatedOpenState) {
      setSourcePopoverOpen(updatedOpenState);
      /**
       * Required to set focus back to an expected place when
       * popover menu closes
       */

      if (!updatedOpenState) {
        setTimeout(function () {
          var _sourceInputRef$curre;

          (_sourceInputRef$curre = sourceInputRef.current) === null || _sourceInputRef$curre === void 0 ? void 0 : _sourceInputRef$curre.focus();
        }, 0);
      }
    },
    onSelectItem: function onSelectItem(item) {
      var _item$id;

      var newSelectedOperator = item !== null && item !== void 0 && item["dataType"] ? context.operators[item["dataType"]][0].id : null;
      dispatch({
        type: "UPDATE_RULE_SELECTED_SOURCE_COLUMN",
        payload: {
          ruleId: ruleId,
          selectedSourceColumnId: (_item$id = item === null || item === void 0 ? void 0 : item["id"]) !== null && _item$id !== void 0 ? _item$id : null,
          selectedOperator: newSelectedOperator,
          type: item === null || item === void 0 ? void 0 : item["valueType"]
        }
      });
    },
    popoverTargetRef: sourceInputRef,
    popoverWidth: (_sourceInputRef$curre2 = sourceInputRef.current) === null || _sourceInputRef$curre2 === void 0 ? void 0 : _sourceInputRef$curre2.offsetWidth,
    searchable: true,
    searchInputClearSearchButtonTooltipText: (_context$searchInputC = context.searchInputClearSearchButtonTooltipText) !== null && _context$searchInputC !== void 0 ? _context$searchInputC : context.t({
      id: TranslationKeys.conditionBuilderSearchInputClearSearchButtonTooltipText
    }),
    searchInputLabelAndPlaceholderText: (_context$searchInputL = context.searchInputLabelAndPlaceholderText) !== null && _context$searchInputL !== void 0 ? _context$searchInputL : context.t({
      id: TranslationKeys.conditionBuilderSearchInputLabelAndPlaceholderText
    })
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "vds-select",
    fill: true,
    icon: selectedSourceColumnObj === null || selectedSourceColumnObj === void 0 ? void 0 : selectedSourceColumnObj.icon,
    onClick: function onClick() {
      return setSourcePopoverOpen(true);
    },
    onKeyDown: function onKeyDown(e) {
      return handelKeyDown(e, "source");
    },
    ref: sourceInputRef,
    rightIcon: ChevronDown32,
    type: "button"
  }, /*#__PURE__*/React__default.createElement(Text, {
    ellipsize: true
  }, (selectedSourceColumnObj === null || selectedSourceColumnObj === void 0 ? void 0 : selectedSourceColumnObj.name) || ((_context$sourcePlaceh = context.sourcePlaceholderText) !== null && _context$sourcePlaceh !== void 0 ? _context$sourcePlaceh : context.t({
    id: TranslationKeys.conditionBuilderSourcePlaceholderText
  })))))), currentCondition["selectedSourceColumnId"] !== null && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, context.operatorsEditable ? /*#__PURE__*/React__default.createElement(FormGroup, {
    className: "vds-condition-builder-form-group",
    label: (_context$operatorLabe = context.operatorLabelText) !== null && _context$operatorLabe !== void 0 ? _context$operatorLabe : context.t({
      id: TranslationKeys.conditionBuilderOperatorLabelText
    }),
    hideLabel: true,
    intent: !!currentCondition["error"] ? "danger" : undefined
  }, /*#__PURE__*/React__default.createElement(ConditionalBuilderPopoverMenu, {
    activeItem: context.operators[(_selectedSourceColumn = selectedSourceColumnObj === null || selectedSourceColumnObj === void 0 ? void 0 : selectedSourceColumnObj.dataType) !== null && _selectedSourceColumn !== void 0 ? _selectedSourceColumn : 0].find(function (operator) {
      return operator.id === currentCondition["selectedOperator"];
    }).name,
    isOpen: operatorPopoverOpen,
    menuItems: selectedSourceColumnObj !== null && selectedSourceColumnObj !== void 0 && selectedSourceColumnObj.dataType ? context.operators[selectedSourceColumnObj.dataType] : [],
    onOpenChange: function onOpenChange(updatedOpenState) {
      setOperatorPopoverOpen(updatedOpenState);
      /**
       * Required to set focus back to an expected place when
       * popover menu closes
       */

      if (!updatedOpenState) {
        setTimeout(function () {
          var _operatorInputRef$cur;

          (_operatorInputRef$cur = operatorInputRef.current) === null || _operatorInputRef$cur === void 0 ? void 0 : _operatorInputRef$cur.focus();
        }, 0);
      }
    },
    onSelectItem: function onSelectItem(item) {
      dispatch({
        type: "UPDATE_RULE_SELECTED_OPERATOR",
        payload: {
          ruleId: ruleId,
          selectedOperator: item === null || item === void 0 ? void 0 : item["id"]
        }
      });
    },
    popoverTargetRef: operatorInputRef,
    popoverWidth: (_operatorInputRef$cur2 = operatorInputRef.current) === null || _operatorInputRef$cur2 === void 0 ? void 0 : _operatorInputRef$cur2.offsetWidth
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "vds-select",
    fill: true,
    onClick: function onClick() {
      return setOperatorPopoverOpen(true);
    },
    onKeyDown: function onKeyDown(e) {
      return handelKeyDown(e, "operator");
    },
    ref: operatorInputRef,
    rightIcon: ChevronDown32,
    type: "button"
  }, /*#__PURE__*/React__default.createElement(Text, {
    ellipsize: true
  }, (_getSelectedOperatorO2 = getSelectedOperatorObj()) === null || _getSelectedOperatorO2 === void 0 ? void 0 : _getSelectedOperatorO2.name)))) : /*#__PURE__*/React__default.createElement(ConditionBuilderOperatorTagWrapper, {
    className: "vds-condition-builder-operator-wrapper"
  }, /*#__PURE__*/React__default.createElement(Tag, {
    intent: "primary"
  }, (_getSelectedOperatorO3 = getSelectedOperatorObj()) === null || _getSelectedOperatorO3 === void 0 ? void 0 : _getSelectedOperatorO3.name)), currentCondition["selectedOperator"] && !currentCondition["selectedOperator"].includes("_noVal") && /*#__PURE__*/React__default.createElement(FormGroup, {
    className: "vds-condition-builder-form-group",
    label: (_context$valueLabelTe = context.valueLabelText) !== null && _context$valueLabelTe !== void 0 ? _context$valueLabelTe : context.t({
      id: TranslationKeys.conditionBuilderValueLabelText
    }),
    hideLabel: true,
    intent: !!currentCondition["error"] ? "danger" : undefined
  }, /*#__PURE__*/React__default.createElement(ConditionalBuilderPopoverMenu, {
    activeItem: currentCondition["value"],
    disabled: !(selectedSourceColumnObj !== null && selectedSourceColumnObj !== void 0 && selectedSourceColumnObj.selectItems) || currentCondition["type"] === "date",
    isOpen: valuePopoverOpen,
    menuItems: (_selectedSourceColumn2 = selectedSourceColumnObj === null || selectedSourceColumnObj === void 0 ? void 0 : selectedSourceColumnObj.selectItems) !== null && _selectedSourceColumn2 !== void 0 ? _selectedSourceColumn2 : [],
    noResultsText: (_context$noResultsTex2 = context.noResultsText) !== null && _context$noResultsTex2 !== void 0 ? _context$noResultsTex2 : context.t({
      id: TranslationKeys.conditionBuilderNoResultsText
    }),
    onOpenChange: function onOpenChange(updatedOpenState) {
      setValuePopoverOpen(updatedOpenState);
      /**
       * Required to set focus back to an expected place when
       * popover menu closes
       */

      if (!updatedOpenState) {
        setTimeout(function () {
          var _valueInputRef$curren2;

          if ( // Related to hack for fixing issue with NumericInput component's ref prop.
          (_valueInputRef$curren2 = valueInputRef.current) !== null && _valueInputRef$curren2 !== void 0 && _valueInputRef$curren2.classList.contains("vds-condition-builder-numeric-input-wrapper-ref")) {
            var _valueInputRef$curren3;

            ((_valueInputRef$curren3 = valueInputRef.current) === null || _valueInputRef$curren3 === void 0 ? void 0 : _valueInputRef$curren3.querySelector("input")).focus();
          } else {
            var _valueInputRef$curren4;

            (_valueInputRef$curren4 = valueInputRef.current) === null || _valueInputRef$curren4 === void 0 ? void 0 : _valueInputRef$curren4.focus();
          }
        }, 0);
      }
    },
    onSelectItem: function onSelectItem(item) {
      dispatch({
        type: "UPDATE_RULE_VALUE",
        payload: {
          ruleId: ruleId,
          type: item.type,
          value: item.name
        }
      });
    },
    popoverTargetRef: valueInputRef,
    popoverWidth: (_valueInputRef$curren5 = valueInputRef.current) === null || _valueInputRef$curren5 === void 0 ? void 0 : _valueInputRef$curren5.offsetWidth,
    searchable: true,
    searchInputClearSearchButtonTooltipText: (_context$searchInputC2 = context.searchInputClearSearchButtonTooltipText) !== null && _context$searchInputC2 !== void 0 ? _context$searchInputC2 : context.t({
      id: TranslationKeys.conditionBuilderSearchInputClearSearchButtonTooltipText
    }),
    searchInputLabelAndPlaceholderText: (_context$searchInputL2 = context.searchInputLabelAndPlaceholderText) !== null && _context$searchInputL2 !== void 0 ? _context$searchInputL2 : context.t({
      id: TranslationKeys.conditionBuilderSearchInputLabelAndPlaceholderText
    })
  }, (selectedSourceColumnObj === null || selectedSourceColumnObj === void 0 ? void 0 : selectedSourceColumnObj.valueType) === "string" ? /*#__PURE__*/React__default.createElement(ConditionalBuilderInputValue, {
    clearPredeterminedValueButtonTooltipText: (_context$clearPredete = context.clearPredeterminedValueButtonTooltipText) !== null && _context$clearPredete !== void 0 ? _context$clearPredete : context.t({
      id: TranslationKeys.conditionBuilderClearPredeterminedValueButtonTooltipText
    }),
    currentCondition: currentCondition,
    dispatch: dispatch,
    valueInputRef: valueInputRef,
    onClick: function onClick() {
      return handelValueInputClick(valueInputRef);
    },
    onKeyDown: function onKeyDown(e) {
      return handelKeyDown(e, "value");
    },
    ruleId: ruleId,
    selectedSourceColumnObj: selectedSourceColumnObj,
    stringValuePlaceholderText: (_context$stringValueP = context.stringValuePlaceholderText) !== null && _context$stringValueP !== void 0 ? _context$stringValueP : context.t({
      id: TranslationKeys.conditionBuilderStringValuePlaceholderText
    }),
    usingPredeterminedValueIconTooltipText: (_context$usingPredete = context.usingPredeterminedValueIconTooltipText) !== null && _context$usingPredete !== void 0 ? _context$usingPredete : context.t({
      id: TranslationKeys.conditionBuilderUsingPredeterminedValueIconTooltipText
    })
  }) : (selectedSourceColumnObj === null || selectedSourceColumnObj === void 0 ? void 0 : selectedSourceColumnObj.valueType) === "number" ? /*#__PURE__*/React__default.createElement(ConditionalBuilderNumericValue, {
    clearPredeterminedValueButtonTooltipText: (_context$clearPredete2 = context.clearPredeterminedValueButtonTooltipText) !== null && _context$clearPredete2 !== void 0 ? _context$clearPredete2 : context.t({
      id: TranslationKeys.conditionBuilderClearPredeterminedValueButtonTooltipText
    }),
    currentCondition: currentCondition,
    dispatch: dispatch,
    valueInputRef: valueInputRef,
    onClick: function onClick() {
      return handelValueInputClick(valueInputRef);
    },
    onKeyDown: function onKeyDown(e) {
      return handelKeyDown(e, "value");
    },
    ruleId: ruleId,
    selectedSourceColumnObj: selectedSourceColumnObj,
    usingPredeterminedValueIconTooltipText: (_context$usingPredete2 = context.usingPredeterminedValueIconTooltipText) !== null && _context$usingPredete2 !== void 0 ? _context$usingPredete2 : context.t({
      id: TranslationKeys.conditionBuilderUsingPredeterminedValueIconTooltipText
    })
  }) : (selectedSourceColumnObj === null || selectedSourceColumnObj === void 0 ? void 0 : selectedSourceColumnObj.valueType) === "date" ? /*#__PURE__*/React__default.createElement(ConditionalBuilderDateValue, {
    clearPredeterminedValueButtonTooltipText: (_context$clearPredete3 = context.clearPredeterminedValueButtonTooltipText) !== null && _context$clearPredete3 !== void 0 ? _context$clearPredete3 : context.t({
      id: TranslationKeys.conditionBuilderClearPredeterminedValueButtonTooltipText
    }),
    currentCondition: currentCondition,
    dateValuePlaceholderText: (_context$dateValuePla = context.dateValuePlaceholderText) !== null && _context$dateValuePla !== void 0 ? _context$dateValuePla : context.t({
      id: TranslationKeys.conditionBuilderDateValuePlaceholderText
    }),
    dispatch: dispatch,
    valueInputRef: valueInputRef,
    onClick: function onClick() {
      return handelValueInputClick(valueInputRef);
    },
    onKeyDown: function onKeyDown(e) {
      return handelKeyDown(e, "value");
    },
    ruleId: ruleId,
    selectedSourceColumnObj: selectedSourceColumnObj,
    usePredeterminedValueButtonTooltipText: (_context$usePredeterm = context.usePredeterminedValueButtonTooltipText) !== null && _context$usePredeterm !== void 0 ? _context$usePredeterm : context.t({
      id: TranslationKeys.conditionBuilderUsePredeterminedValueButtonTooltipText
    }),
    usingPredeterminedValueIconTooltipText: (_context$usingPredete3 = context.usingPredeterminedValueIconTooltipText) !== null && _context$usingPredete3 !== void 0 ? _context$usingPredete3 : context.t({
      id: TranslationKeys.conditionBuilderUsingPredeterminedValueIconTooltipText
    })
  }) : null)))), !!currentCondition["error"] && /*#__PURE__*/React__default.createElement(ConditionBuilderFormGroupError, {
    className: "vds-condition-builder-form-group-error"
  }, currentCondition["error"])), /*#__PURE__*/React__default.createElement(ConditionBuilderRuleActions, {
    className: "vds-condition-builder-rule-actions",
    vertical: context.vertical
  }, (selectedSourceColumnObj === null || selectedSourceColumnObj === void 0 ? void 0 : selectedSourceColumnObj.additionalControls) && (selectedSourceColumnObj === null || selectedSourceColumnObj === void 0 ? void 0 : selectedSourceColumnObj.additionalControls), /*#__PURE__*/React__default.createElement(IconOnlyButton, {
    icon: SubtractAlt32,
    minimal: true,
    onClick: function onClick() {
      dispatch({
        type: "REMOVE_CHILD",
        payload: {
          ruleId: ruleId
        }
      });
    },
    text: "Remove condition",
    type: "button"
  }))));
};

var ConditionBuilderRootElement = function ConditionBuilderRootElement(_ref43) {
  var _context$andCombinato3, _context$ifAllCombina3, _context$ifAllCombina4, _context$ifAnyCombina3, _context$ifAnyCombina4, _context$orCombinator3, _context$addCondition2, _context$addSubCondit2, _context$subCondition2;

  var rootElement = _ref43.rootElement;

  var _useContext3 = useContext(ConditionBuilderContext),
      dispatch = _useContext3.dispatch,
      conditionsData = _useContext3.conditionsData,
      readOnly = _useContext3.readOnly,
      vertical = _useContext3.vertical,
      context = _objectWithoutProperties(_useContext3, _excluded3);

  var INITIAL_DEPTH = 0;

  var renderChildren = function renderChildren(children, combinator, depth) {
    return children.map(function (childId) {
      return conditionsData.conditions[childId];
    }).map(function (childItem) {
      if (childItem["children"]) {
        return /*#__PURE__*/React__default.createElement(ConditionBuilderGroup, {
          combinator: combinator,
          depth: depth + 1,
          groupCombinator: childItem["groupCombinator"],
          groupId: childItem.id,
          key: childItem.id
        }, renderChildren(childItem["children"], childItem["groupCombinator"], depth + 1));
      } else {
        return /*#__PURE__*/React__default.createElement(ConditionBuilderRule, {
          combinator: combinator,
          key: childItem.id,
          ruleId: childItem.id
        });
      }
    });
  };

  return /*#__PURE__*/React__default.createElement(ConditionBuilderGroupWrapper, {
    className: "vds-condition-builder-group",
    combinatorEditable: context.combinatorsEditable,
    readOnly: readOnly,
    vertical: vertical
  }, /*#__PURE__*/React__default.createElement(ConditionBuilderHeader, {
    andCombinatorTagText: (_context$andCombinato3 = context.andCombinatorTagText) !== null && _context$andCombinato3 !== void 0 ? _context$andCombinato3 : context.t({
      id: TranslationKeys.conditionBuilderAndCombinatorTagText
    }),
    combinatorEditable: context.combinatorsEditable,
    dispatch: dispatch,
    groupId: rootElement.id,
    ifAllCombinatorDescriptionText: (_context$ifAllCombina3 = context.ifAllCombinatorDescriptionText) !== null && _context$ifAllCombina3 !== void 0 ? _context$ifAllCombina3 : context.t({
      id: TranslationKeys.conditionBuilderIfAllCombinatorDescriptionText
    }),
    ifAllCombinatorSelectionText: (_context$ifAllCombina4 = context.ifAllCombinatorSelectionText) !== null && _context$ifAllCombina4 !== void 0 ? _context$ifAllCombina4 : context.t({
      id: TranslationKeys.conditionBuilderIfAllCombinatorSelectionText
    }),
    ifAnyCombinatorDescriptionText: (_context$ifAnyCombina3 = context.ifAnyCombinatorDescriptionText) !== null && _context$ifAnyCombina3 !== void 0 ? _context$ifAnyCombina3 : context.t({
      id: TranslationKeys.conditionBuilderIfAnyCombinatorDescriptionText
    }),
    ifAnyCombinatorSelectionText: (_context$ifAnyCombina4 = context.ifAnyCombinatorSelectionText) !== null && _context$ifAnyCombina4 !== void 0 ? _context$ifAnyCombina4 : context.t({
      id: TranslationKeys.conditionBuilderIfAnyCombinatorSelectionText
    }),
    orCombinatorTagText: (_context$orCombinator3 = context.orCombinatorTagText) !== null && _context$orCombinator3 !== void 0 ? _context$orCombinator3 : context.t({
      id: TranslationKeys.conditionBuilderOrCombinatorTagText
    }),
    readOnly: readOnly,
    selectedCombinator: rootElement.groupCombinator,
    vertical: vertical
  }), renderChildren(rootElement.children, rootElement.groupCombinator, INITIAL_DEPTH), !readOnly ? /*#__PURE__*/React__default.createElement(ConditionBuilderFooter, {
    addConditionText: (_context$addCondition2 = context.addConditionText) !== null && _context$addCondition2 !== void 0 ? _context$addCondition2 : context.t({
      id: TranslationKeys.conditionBuilderAddConditionText
    }),
    addSubConditionText: (_context$addSubCondit2 = context.addSubConditionText) !== null && _context$addSubCondit2 !== void 0 ? _context$addSubCondit2 : context.t({
      id: TranslationKeys.conditionBuilderAddSubConditionText
    }),
    depth: INITIAL_DEPTH,
    dispatch: dispatch,
    groupId: rootElement.id,
    maxDepth: context.maxDepth,
    subConditionMaxLimitText: (_context$subCondition2 = context.subConditionMaxLimitText) !== null && _context$subCondition2 !== void 0 ? _context$subCondition2 : context.t({
      id: TranslationKeys.conditionBuilderSubConditionMaxLimitText
    })
  }) :
  /*#__PURE__*/
  // Used to help preserve CSS for dotted connector lines.
  React__default.createElement(ConditionBuilderFooterPlaceholder, null));
};

var ConditionBuilder = /*#__PURE__*/forwardRef(function (_ref44, ref) {
  var andCombinatorTagText = _ref44.andCombinatorTagText,
      addConditionText = _ref44.addConditionText,
      addSubConditionText = _ref44.addSubConditionText,
      className = _ref44.className,
      clearPredeterminedValueButtonTooltipText = _ref44.clearPredeterminedValueButtonTooltipText,
      _ref44$combinatorsEdi = _ref44.combinatorsEditable,
      combinatorsEditable = _ref44$combinatorsEdi === void 0 ? true : _ref44$combinatorsEdi,
      externalData = _ref44.conditionsData,
      dateValuePlaceholderText = _ref44.dateValuePlaceholderText,
      _ref44$defaultConditi = _ref44.defaultConditionsData,
      defaultConditionsData = _ref44$defaultConditi === void 0 ? {
    conditions: {},
    rootId: null
  } : _ref44$defaultConditi,
      ifAllCombinatorSelectionText = _ref44.ifAllCombinatorSelectionText,
      ifAnyCombinatorSelectionText = _ref44.ifAnyCombinatorSelectionText,
      ifAllCombinatorDescriptionText = _ref44.ifAllCombinatorDescriptionText,
      ifAnyCombinatorDescriptionText = _ref44.ifAnyCombinatorDescriptionText,
      initialCombinatorValue = _ref44.initialCombinatorValue,
      _ref44$maxDepth = _ref44.maxDepth,
      maxDepth = _ref44$maxDepth === void 0 ? 2 : _ref44$maxDepth,
      noResultsText = _ref44.noResultsText,
      onConditionsChange = _ref44.onConditionsChange,
      operatorLabelText = _ref44.operatorLabelText,
      operators = _ref44.operators,
      _ref44$operatorsEdita = _ref44.operatorsEditable,
      operatorsEditable = _ref44$operatorsEdita === void 0 ? true : _ref44$operatorsEdita,
      orCombinatorTagText = _ref44.orCombinatorTagText,
      _ref44$readOnly = _ref44.readOnly,
      readOnly = _ref44$readOnly === void 0 ? false : _ref44$readOnly,
      searchInputClearSearchButtonTooltipText = _ref44.searchInputClearSearchButtonTooltipText,
      searchInputLabelAndPlaceholderText = _ref44.searchInputLabelAndPlaceholderText,
      selectValuePlaceholderText = _ref44.selectValuePlaceholderText,
      sourceColumns = _ref44.sourceColumns,
      sourceLabelText = _ref44.sourceLabelText,
      sourcePlaceholderText = _ref44.sourcePlaceholderText,
      stringValuePlaceholderText = _ref44.stringValuePlaceholderText,
      subConditionMaxLimitText = _ref44.subConditionMaxLimitText,
      _ref44$t = _ref44.t,
      t = _ref44$t === void 0 ? defaultTranslate : _ref44$t,
      usePredeterminedValueButtonTooltipText = _ref44.usePredeterminedValueButtonTooltipText,
      usingPredeterminedValueIconTooltipText = _ref44.usingPredeterminedValueIconTooltipText,
      valueLabelText = _ref44.valueLabelText,
      _ref44$vertical = _ref44.vertical,
      vertical = _ref44$vertical === void 0 ? false : _ref44$vertical,
      props = _objectWithoutProperties(_ref44, _excluded4);

  var isBreakpointMaxMedium = useMedia("(max-width: ".concat(breakpointMaxSmall, ")"));

  var reducer = function reducer(state, action) {
    var newState = _objectSpread({}, state);

    switch (action.type) {
      case "UPDATE_GROUP_COMBINATOR":
        var _action$payload = action.payload,
            groupId = _action$payload.groupId,
            groupCombinator = _action$payload.groupCombinator;
        newState.conditions = _objectSpread(_objectSpread({}, newState.conditions), {}, _defineProperty({}, groupId, _objectSpread(_objectSpread({}, newState.conditions[groupId]), {}, {
          groupCombinator: groupCombinator
        })));
        return newState;

      case "ADD_CHILD":
        {
          var _action$payload2 = action.payload,
              _groupId = _action$payload2.groupId,
              type = _action$payload2.type;
          var itemId = v4();

          if (type === "initial") {
            var _objectSpread3;

            var rootId = v4();
            newState.rootId = rootId;
            newState.conditions = _objectSpread(_objectSpread({}, newState.conditions), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, rootId, {
              id: rootId,
              parent: null,
              children: [itemId],
              groupCombinator: initialCombinatorValue || "any"
            }), _defineProperty(_objectSpread3, itemId, {
              error: null,
              id: itemId,
              parent: rootId,
              selectedSourceColumnId: null,
              selectedOperator: null,
              value: null
            }), _objectSpread3));
          } else {
            newState.conditions = _objectSpread(_objectSpread({}, newState.conditions), {}, _defineProperty({}, _groupId, _objectSpread(_objectSpread({}, newState.conditions[_groupId]), {}, {
              children: [].concat(_toConsumableArray(newState.conditions[_groupId]["children"]), [itemId])
            })));

            if (type === "rule") {
              newState.conditions = _objectSpread(_objectSpread({}, newState.conditions), {}, _defineProperty({}, itemId, {
                error: null,
                id: itemId,
                parent: _groupId,
                selectedSourceColumnId: null,
                selectedOperator: null,
                value: null
              }));
            } else if (type === "group") {
              var _objectSpread6;

              var childId = v4();
              newState.conditions = _objectSpread(_objectSpread({}, newState.conditions), {}, (_objectSpread6 = {}, _defineProperty(_objectSpread6, itemId, {
                id: itemId,
                parent: _groupId,
                children: [childId],
                groupCombinator: initialCombinatorValue || "any"
              }), _defineProperty(_objectSpread6, childId, {
                error: null,
                id: childId,
                parent: itemId,
                selectedSourceColumnId: null,
                selectedOperator: null,
                value: null
              }), _objectSpread6));
            }
          }

          return newState;
        }

      case "REMOVE_CHILD":
        {
          var ruleId = action.payload.ruleId;
          var ruleParentId = newState.conditions[ruleId].parent;

          var removeRootIdIfEmpty = function removeRootIdIfEmpty(conditions) {
            if (Object.keys(_objectSpread(_objectSpread({}, newState), {}, {
              conditions: conditions
            }).conditions).length === 0) {
              newState.rootId = null;
            }
          };

          var removeChildFromGroup = function removeChildFromGroup(child, group) {
            return newState.conditions = _objectSpread(_objectSpread({}, newState.conditions), {}, _defineProperty({}, group, _objectSpread(_objectSpread({}, newState.conditions[group]), {}, {
              children: newState.conditions[group]["children"].filter(function (item) {
                return item !== child;
              })
            })));
          };

          var recursivelyRemoveItems = function recursivelyRemoveItems(item, parent) {
            if (parent) {
              removeChildFromGroup(item, parent);
            }

            if (newState.conditions[parent]["children"].length === 0) {
              var grandparent = newState.conditions[parent].parent;

              if (grandparent) {
                removeChildFromGroup(parent, grandparent);

                var _recursivelyRemoveIte = recursivelyRemoveItems(parent, grandparent),
                    _recursivelyRemoveIte2 = _recursivelyRemoveIte.conditions;
                    _recursivelyRemoveIte2[parent];
                    _recursivelyRemoveIte2[item];
                    var conditions = _objectWithoutProperties(_recursivelyRemoveIte2, [parent, item].map(_toPropertyKey));

                removeRootIdIfEmpty(conditions);
                return _objectSpread(_objectSpread({}, newState), {}, {
                  conditions: conditions
                });
              } else {
                var _newState$conditions = newState.conditions;
                    _newState$conditions[parent];
                    _newState$conditions[item];
                    var _conditions = _objectWithoutProperties(_newState$conditions, [parent, item].map(_toPropertyKey));

                removeRootIdIfEmpty(_conditions);
                return _objectSpread(_objectSpread({}, newState), {}, {
                  conditions: _conditions
                });
              }
            } else {
              var _newState$conditions2 = newState.conditions;
                  _newState$conditions2[item];
                  var _conditions2 = _objectWithoutProperties(_newState$conditions2, [item].map(_toPropertyKey));

              return _objectSpread(_objectSpread({}, newState), {}, {
                conditions: _conditions2
              });
            }
          };

          return recursivelyRemoveItems(ruleId, ruleParentId);
        }

      case "UPDATE_RULE_SELECTED_SOURCE_COLUMN":
        {
          var _action$payload3 = action.payload,
              _ruleId = _action$payload3.ruleId,
              selectedSourceColumnId = _action$payload3.selectedSourceColumnId,
              selectedOperator = _action$payload3.selectedOperator,
              _type = _action$payload3.type;
          newState.conditions = _objectSpread(_objectSpread({}, newState.conditions), {}, _defineProperty({}, _ruleId, _objectSpread(_objectSpread({}, newState.conditions[_ruleId]), {}, {
            error: null,
            selectedSourceColumnId: selectedSourceColumnId,
            selectedOperator: selectedOperator,
            type: _type,
            value: null
          })));
          return newState;
        }

      case "UPDATE_RULE_SELECTED_OPERATOR":
        {
          var _action$payload4 = action.payload,
              _ruleId2 = _action$payload4.ruleId,
              _selectedOperator = _action$payload4.selectedOperator;
          newState.conditions = _objectSpread(_objectSpread({}, newState.conditions), {}, _defineProperty({}, _ruleId2, _objectSpread(_objectSpread({}, newState.conditions[_ruleId2]), {}, {
            error: null,
            selectedOperator: _selectedOperator
          })));

          if (_selectedOperator.includes("_noVal")) {
            newState.conditions = _objectSpread(_objectSpread({}, newState.conditions), {}, _defineProperty({}, _ruleId2, _objectSpread(_objectSpread({}, newState.conditions[_ruleId2]), {}, {
              value: null
            })));
          }

          return newState;
        }

      case "UPDATE_RULE_VALUE":
        {
          var _action$payload5 = action.payload,
              _ruleId3 = _action$payload5.ruleId,
              _type2 = _action$payload5.type,
              _value = _action$payload5.value;
          newState.conditions = _objectSpread(_objectSpread({}, newState.conditions), {}, _defineProperty({}, _ruleId3, _objectSpread(_objectSpread({}, newState.conditions[_ruleId3]), {}, {
            error: null,
            type: _type2,
            value: _value
          })));
          return newState;
        }

      case "EXTERNAL_STATE_UPDATE":
        {
          var externallyUpdatedState = action.payload.externallyUpdatedState;

          var _newState = R.clone(externallyUpdatedState);

          return _newState;
        }

      default:
        return state;
    }
  };

  var isControlled = !!externalData;

  var _useReducer = useReducer(reducer, defaultConditionsData),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      internalData = _useReducer2[0],
      intDispatch = _useReducer2[1];

  var extDispatch = function extDispatch(action) {
    if (externalData) {
      var newState = reducer(externalData, action);
      onConditionsChange(newState);
    }
  };

  var conditionsData = isControlled ? externalData : internalData;
  var dispatch = isControlled ? extDispatch : intDispatch;

  var renderRootNode = function renderRootNode(data) {
    if (data.rootId && Object.keys(data.conditions).length !== 0) {
      return /*#__PURE__*/React__default.createElement(ConditionBuilderRootElement, {
        rootElement: data.conditions[data.rootId]
      });
    }

    return /*#__PURE__*/React__default.createElement(Button, {
      fill: true,
      icon: AddAlt32,
      minimal: true,
      onClick: function onClick() {
        dispatch({
          type: "ADD_CHILD",
          payload: {
            type: "initial"
          }
        });
      },
      text: addConditionText !== null && addConditionText !== void 0 ? addConditionText : t({
        id: TranslationKeys.conditionBuilderAddConditionText
      }),
      type: "button"
    });
  };

  useEffect(function () {
    if (!isControlled) {
      onConditionsChange(internalData);
    }
  }, [internalData]);
  return /*#__PURE__*/React__default.createElement(ConditionBuilderWrapper, _extends({
    className: cx("vds-condition-builder", className),
    ref: ref,
    vertical: isBreakpointMaxMedium ? true : vertical
  }, props), /*#__PURE__*/React__default.createElement(ConditionBuilderContext.Provider, {
    value: {
      andCombinatorTagText: andCombinatorTagText,
      addConditionText: addConditionText,
      addSubConditionText: addSubConditionText,
      clearPredeterminedValueButtonTooltipText: clearPredeterminedValueButtonTooltipText,
      combinatorsEditable: combinatorsEditable,
      conditionsData: conditionsData,
      dateValuePlaceholderText: dateValuePlaceholderText,
      dispatch: dispatch,
      ifAllCombinatorSelectionText: ifAllCombinatorSelectionText,
      ifAnyCombinatorSelectionText: ifAnyCombinatorSelectionText,
      ifAllCombinatorDescriptionText: ifAllCombinatorDescriptionText,
      ifAnyCombinatorDescriptionText: ifAnyCombinatorDescriptionText,
      maxDepth: maxDepth,
      noResultsText: noResultsText,
      operatorLabelText: operatorLabelText,
      operators: operators,
      operatorsEditable: operatorsEditable,
      orCombinatorTagText: orCombinatorTagText,
      readOnly: readOnly,
      searchInputClearSearchButtonTooltipText: searchInputClearSearchButtonTooltipText,
      searchInputLabelAndPlaceholderText: searchInputLabelAndPlaceholderText,
      selectValuePlaceholderText: selectValuePlaceholderText,
      sourceColumns: sourceColumns,
      sourceLabelText: sourceLabelText,
      sourcePlaceholderText: sourcePlaceholderText,
      stringValuePlaceholderText: stringValuePlaceholderText,
      subConditionMaxLimitText: subConditionMaxLimitText,
      t: t,
      usePredeterminedValueButtonTooltipText: usePredeterminedValueButtonTooltipText,
      usingPredeterminedValueIconTooltipText: usingPredeterminedValueIconTooltipText,
      valueLabelText: valueLabelText,
      vertical: isBreakpointMaxMedium ? true : vertical
    }
  }, renderRootNode(conditionsData)));
});

export { ConditionBuilder };
//# sourceMappingURL=condition-builder.js.map
